import { render, staticRenderFns } from "./giftAlertView.vue?vue&type=template&id=50ee4062&scoped=true"
import script from "./giftAlertView.vue?vue&type=script&lang=js"
export * from "./giftAlertView.vue?vue&type=script&lang=js"
import style0 from "./giftAlertView.vue?vue&type=style&index=0&id=50ee4062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee4062",
  null
  
)

export default component.exports